import React from "react";
import Navbar from "./modules/Navbar";
import Hero from "./modules/Hero";
import About from "./modules/About";
import Prizes from "./modules/Prizes";
// import Judges from "./modules/Judges";
// import Theme from "./modules/Theme";
import Timeline from "./modules/Timeline";
import Training from "./modules/Training";
import Gallery from "@/modules/Gallery";
// import Register from "./modules/Register";
import Partners from "./modules/Partners";
import Faq from "./modules/Faq";
import Contact from "./modules/Contact";
import Footer from "./modules/Footer";
import ScrollButton from "./modules/ScrollButton";
import Application from "@/modules/Application";
// import { Helmet } from "react-helmet";
import MessageEN from "./l10n/en_id";
import MessageID from "./l10n/id_id";
import MessageENSG from "./l10n/en_sg";
import Translator from '@/modules/translator';
import translator from '@/modules/i18n';
import { $t } from '@/modules/i18n';

import "./scss/App.scss";

const LANG = navigator.language.slice(0, 2);
const IS_EN = LANG === 'en-US' || LANG === 'en'
function getMessage (lang = LANG) {
  // const isSG = process.env.REACT_APP_COUNTRY === 'sg';
  var Message;
  // if (isSG) {
  //   Message = MessageENSG;
  // } else {
    switch (lang) {
      case "en-US":
      case "en":
        Message = MessageEN;
        break;
      case "id-ID":
      case "id":
        Message = MessageID;
        break;
      default:
        Message = MessageID;
        break;
    }
  // }
  return Message;
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: LANG,
      message: getMessage(LANG)
    };
    
    this.onChildChange = this.onChildChange.bind(this);
    this.url = `https://careers.shopee.co.id/ndsc`;
    this.imageURL = `https://careers.shopee.sg/ndsc/images/ndsc_cover.png`;
  }

  onChildChange(v) {
    translator.switchLanguage(v, ['career']).then(() => {
      this.setState({
        lang: v,
        message: getMessage(v)
      });
    });
  
  }

  getHelmetScript() {
    const msg = this.state.message.application;
    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: msg.title,
        description: msg.desc,
        image: msg.siteImageURL,
        startDate: msg.seoStartdate,
        endDate: msg.seoEnddate,
        url: msg.siteURL,
        Performer: msg.seoPerformer,
        audience: {
          "@type": msg.seoAudienceType,
          educationalRole:
            "Students and Professionals passionate about Data Science"
        },
        location: {
          "@type": "Place",
          name: msg.seolocationName,
          address: msg.seolocationAddress,
          hasMap: msg.seoHasMap
        }
      })
    }]
  }

  render() {
    const Message = this.state.message;
    const script = this.getHelmetScript();
    const cureentLang = IS_EN ? 'en' : 'id';

    return (
      <div className={`App`}>
        {/* <Popup Message={Message}/> */}
        <Application message={Message.application} url={this.url} imageURL={this.imageURL} script={script} />
        <Navbar
          Message={Message}
          onInputChange={this.onChildChange}
          value={cureentLang}
          // isSG={isSG}
        />
        <ScrollButton scrollStepInPx="50" delayInMs="1.66" />
        <Hero Message={Message} />
        <About Message={Message} />
        <div className="guest">
          <h2 className="intro-title">{$t(Message.guest.title)}</h2>
          <div className="guest-wrapper">
          {
            Message.guest.list.map(item => (
              <div className="guest-item" key={item.name}>
                <div className="guest-item-content">
                  <span className="guest-date">{$t(item.date)}</span>
                  <p className="guest-name">{$t(item.name)}</p>
                </div>
                <p className="guest-desc">{$t(item.desc)}</p>
              </div>
            ))
          }
          </div>
        </div>
        {/* { isSG ? <Theme Message={Message} /> : null } */}
        <Prizes Message={Message} />
        {/* { isSG ? <Judges Message={Message} /> : null } */}

        <Timeline Message={Message} />
        <Training Message={Message} />
        {/* { isSG ? <Register Message={Message} /> : null } */}

        {/*  <Video Message={Message}/> */}
        <Partners Message={Message} />
        <Faq Message={Message} />
        <Contact Message={Message} />
        <Gallery message={Message.gallery} />
        <Footer
          Message={Message}
          onInputChange={this.onChildChange}
          value={cureentLang}
        />
        {/* <h2>{this.state.lang}</h2> */}
      </div>
    );
  }
}

export default Translator(App, getMessage, { locale: IS_EN ? 'en' : 'id' });
